<div class="modal-header"><h2>Create a new APSIS One account</h2></div>

<ng-container
  [ngTemplateOutlet]="create"
  [ngTemplateOutletContext]="{
    header: 'Account Created',
    status: createCommandState
  }"
></ng-container>

<ng-container
  [ngTemplateOutlet]="create"
  [ngTemplateOutletContext]="{
    header: 'Audience Bootstrap',
    status: bootstrapCommandState
  }"
></ng-container>

<ng-container
  [ngTemplateOutlet]="create"
  [ngTemplateOutletContext]="{
    header: 'Account owner invited',
    status: inviteCommandState
  }"
></ng-container>

<div class="completed alert alert-info" *ngIf="isAllStepsSuccess">
  <i class="fas fa-check"></i> All steps are completed!
</div>

<div class="footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    [disabled]="
      isCreateInProgress || isBootstrapInProgress || isInviteInProgress
    "
    (click)="activeModal.close()"
  >
    Close
  </button>
</div>

<ng-template #create let-header="header" let-status="status">
  <div class="status">
    <strong>{{ header }}</strong>
    <ng-container [ngSwitch]="status">
      <i *ngSwitchCase="CommandState.Success" class="fas fa-check-circle"></i>
      <i
        *ngSwitchCase="CommandState.Pending"
        class="fas fa-check-circle pending"
      ></i>
      <i *ngSwitchCase="CommandState.Failed" class="fas fa-times-circle"></i>
      <app-loading-spinner
        *ngSwitchCase="CommandState.Progress"
        size="md"
      ></app-loading-spinner>
    </ng-container>
  </div>
</ng-template>
